import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor } from '../../../util/theme';

const ReviewItemContentContainer = styled.div`
  background-color: ${getColor('accentGreen')};

  clip-path: polygon(
    0% 10%,
    15% 10%,
    15% 0%,
    100% 0,
    100% 95%,
    90% 95%,
    90% 100%,
    80% 95%,
    0 95%
  );

  position: relative;

  height: 500px;

  @media (min-width: ${getBreakpoint('sm')}) {
    height: 325px;
  }

  @media (min-width: ${getBreakpoint('md')}) {
    height: 425px;
  }

  @media (min-width: ${getBreakpoint('lg')}) {
    height: 500px;
  }
`;

export default ReviewItemContentContainer;
